import { ClientPaymentDto, ClientPaymentDtoLatestStateEnum } from '../../../../generated-api'
import { formatCurrencyAndAmount } from '../../../utils/stringUtils'

export const TotalAmountCard = ({ payment }: { payment: ClientPaymentDto }) => {
    const { grossAmount, latestState, currency, terminalTipAmount, grossAmountAfterAddingTerminalTip } = payment
    const isIntegratedTerminal = payment.paymentMethod === 'INTEGRATED_TERMINAL'

    return (
        <div
            className={`flex-col flex-1 rounded-lg p-4 shadow-lg ${
                latestState === ClientPaymentDtoLatestStateEnum.CAPTURED
                    ? 'bg-green-lightest'
                    : latestState === ClientPaymentDtoLatestStateEnum.FAILED
                    ? 'bg-orange-lightest'
                    : 'bg-yellow-lightest'
            }`}
        >
            <h3 className="text-lg">Total amount</h3>

            {isIntegratedTerminal ? (
                <>
                    <p className="font-moret">{formatCurrencyAndAmount(currency, grossAmountAfterAddingTerminalTip)}</p>

                    <div className="flex justify-between mt-1">
                        <h3 className="text-base">Original amount</h3>
                        <span>{formatCurrencyAndAmount(currency, grossAmount)}</span>
                    </div>
                    <div className="flex justify-between">
                        <h3 className="text-base">Terminal tip</h3>
                        <span>{formatCurrencyAndAmount(currency, terminalTipAmount)}</span>
                    </div>
                </>
            ) : (
                <p className="font-moret">{formatCurrencyAndAmount(currency, grossAmount)}</p>
            )}
        </div>
    )
}
